module.exports = __webpack_public_path__ + "img/case41.66690997.png";